// extracted by mini-css-extract-plugin
export default {"title":"changePassword_title__BYYUy"};